import SEO from '../components/SEO';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import ResourcesSection from '../components/ResourcesSection';
import SelfAssessmentModal from '../components/SelfAssessmentModal';
import AppointmentModal from '../components/AppointmentModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MentalHealthResourcesPage = () => {
  const [showSelfAssessmentModal, setShowSelfAssessmentModal] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [blogPosts, setBlogPosts] = useState([]);
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [blogRes, insuranceRes] = await Promise.all([
        axios.get(`${API}/blog`),
        axios.get(`${API}/insurance`)
      ]);

      setBlogPosts(blogRes.data);
      setInsuranceProviders(insuranceRes.data);
    } catch (error) {
      // Error handled silently
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Mental Health Resources" description="Mental health education resources, coping strategies, and wellness information from SDORA Wellbeing LLC." path="/resources/mental-health" />
      <ResourcesSection 
        blogPosts={blogPosts} 
        onTakeSelfAssessment={() => setShowSelfAssessmentModal(true)}
      />
      <Footer />
      
      {showSelfAssessmentModal && (
        <SelfAssessmentModal 
          onClose={() => {
            setShowSelfAssessmentModal(false);
            setShowAppointmentModal(true);
          }}
        />
      )}
      
      {showAppointmentModal && (
        <AppointmentModal 
          onClose={() => setShowAppointmentModal(false)}
          insuranceProviders={insuranceProviders}
        />
      )}
    </div>
  );
};

export default MentalHealthResourcesPage;
